import React from 'react'
import { connect } from 'react-redux'
import { Button, Col, Row, Toast, ToastBody, ToastHeader } from 'reactstrap'

const CustomToast = ({
  isTostOpen,
  duplicatedContacts,
  toggleToast,
  addNewContact,
  header = 'Duplicated Contacts',
  infoMessage = 'Would You like to add the new contact?',
}) => {
  return (
    <div className='p-3 my-2 rounded customTost'>
      <Toast isOpen={isTostOpen}>
        <ToastHeader toggle={toggleToast}>{header}</ToastHeader>
        {duplicatedContacts && Object.keys(duplicatedContacts).length && (
          <ToastBody className='customTost__body'>
            {duplicatedContacts.map((i, index) => {
              return (
                <div key={index}>
                  {`${i.name} already exists in the CRM`} <br />
                  {`mc Number: ${i.mcNumber || ''}`} <br />
                  {`dot Number: ${i.dotNumber || ''}`} <br />
                  {`Owner: ${i.ownerName || ''}`} <br />
                  {`Phone: ${i.businessPhone || ''}`} <br />
                  {`${i.addressCity} ${i.addressState} ${i.addressZip}`} <br />
                  {`${i.addressCountry || ''}`} <br />
                  <hr />
                </div>
              )
            })}
          </ToastBody>
        )}
        <Row className='my-3 mx-auto'>
          <Col xs={12}>
            <div className='font-weight-bold'>{infoMessage}</div>
          </Col>
        </Row>
        <Row className='my-3 mx-auto'>
          <Col xs={6}>
            <Button className='btn btn-danger' onClick={toggleToast}>
              Decline
            </Button>
          </Col>
          <Col xs={6}>
            <Button className='btn btn-success float-right' onClick={addNewContact}>
              Accept
            </Button>
          </Col>
        </Row>
      </Toast>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    duplicatedContacts: state.contacts.duplicatedContacts,
  }
}

export default connect(mapStateToProps)(CustomToast)
